// Store location - will be updated dynamically from settings
let STORE_COORDINATES = {
  latitude: null,
  longitude: null,
};

let DELIVERY_RADIUS = null;

// Function to update settings from admin
export const updateDeliverySettings = (settings) => {
  if (settings.latitude && settings.longitude) {
    STORE_COORDINATES = {
      latitude: Number(settings.latitude),
      longitude: Number(settings.longitude),
    };
  }
  if (settings.deliveryRadius != null) {
    DELIVERY_RADIUS = Number(settings.deliveryRadius);
  }
};

const toRadians = (value) => (value * Math.PI) / 180;

export const calculateDistanceKm = (start, end) => {
  const earthRadiusKm = 6371;
  const latDelta = toRadians(end.latitude - start.latitude);
  const lonDelta = toRadians(end.longitude - start.longitude);

  const a =
    Math.sin(latDelta / 2) * Math.sin(latDelta / 2) +
    Math.cos(toRadians(start.latitude)) *
      Math.cos(toRadians(end.latitude)) *
      Math.sin(lonDelta / 2) *
      Math.sin(lonDelta / 2);

  const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
  return earthRadiusKm * c;
};

export const getDeliveryPlan = (customerCoordinates) => {
  if (
    !customerCoordinates ||
    Number.isNaN(Number(customerCoordinates.latitude)) ||
    Number.isNaN(Number(customerCoordinates.longitude))
  ) {
    return {
      distanceKm: null,
      band: null,
      estimatedTime: '',
      ruleText: 'Latitude and longitude are required to calculate delivery time.',
    };
  }

  const normalizedCoordinates = {
    latitude: Number(customerCoordinates.latitude),
    longitude: Number(customerCoordinates.longitude),
  };

  const distanceKm = calculateDistanceKm(STORE_COORDINATES, normalizedCoordinates);

  if (distanceKm > DELIVERY_RADIUS) {
    return {
      distanceKm,
      band: 'out_of_range',
      estimatedTime: '',
      ruleText: `Delivery available only up to ${DELIVERY_RADIUS} km from store.`,
    };
  }

  if (distanceKm < 4) {
    return {
      distanceKm,
      band: '0_4',
      estimatedTime: '15-30 minutes',
      ruleText: 'Estimated delivery: 15-30 minutes',
    };
  }

  return {
    distanceKm,
    band: '4_10',
    estimatedTime: '25-65 minutes',
    ruleText: 'Estimated delivery: 25-65 minutes',
  };
};

export const getStoreCoordinates = () => STORE_COORDINATES;

export const getDeliveryRadius = () => DELIVERY_RADIUS;
